export default [
  {
    path: 'detalhes/:employee_id',
    name: 'details_employees',
    component: () => import('./ShowEmployee.vue'),
    meta: {
      name: 'Detalhes do Funcionário',
      auth: true,
      user: 'Admin',
    },
  },
]
